import {
  PURCHASE_COMPLETED,
  PURCHASE_FAILED,
  PURCHASE_REQUESTED,
} from '../actions/PurchaseLeads';

const initialState = {
  loading: true,
  data: {},
};

const purchaseLeads = (state = initialState, action) => {
  switch (action.type) {
    case PURCHASE_REQUESTED:
      return initialState;
    case PURCHASE_COMPLETED:
      return {
        loading: false,
      };
    case PURCHASE_FAILED:
      return Object.assign({}, initialState, {
        loading: false,
      });
    default:
      return state;
  }
};

export default purchaseLeads;
